<template>
  <div class="container mt-4">
    <div class="row justify-content-center">
      <div class="col-12 col-md-9 col-lg-7">
        <div class="bg-light">
          <h1 class="font-weight-light text-center">
            My <b>{{ this.video.videoTitle }}</b> Videos
          </h1>
          <div>
            <video width="640" height="380" controls>
              <source :src="this.video.largeURL" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div class="text-center pb-4">
            <a
              class="mt-4 btn btn-primary rounded-pill"
              v-b-modal.new-video
              @click.prevent="hideMenu()"
              role="button"
            >
              <span>Begin Personalization</span>
            </a>

            <b-modal id="new-video" hide-footer @hidden="onHidden">
              <form>
                <Steps />
              </form>
              <br /><br />
            </b-modal>
          </div>
        </div>
      </div>
    </div>
    <YourVideos />
    <Share />
  </div>
</template>
<script>
import Steps from "./Steps";
import YourVideos from "./YourVideos";
import Share from "./Share";
export default {
  name: "Personalize",
  computed: {
    video: {
      get() {
        return this.$store.state.srcVideos.find(
          (x) => x.id === this.$store.state.customization.srcVid
        );
      },
    },
  },
  data: function() {
    return {
      userID: this.$route.params.userID,
      srcVideoID: this.$route.params.videoID,
      initStep: this.$store.commit("changeStep", 1),
    };
  },
  components: {
    Steps,
    YourVideos,
    Share,
  },
  mounted() {
    this.$root.$emit("bv::hide::popover");
  },
  methods: {
    onHidden() {
      // fires when modal is closed
      this.$store.commit("resetCustomization");
      this.$bvModal.hide("confirm-delete");
    },
    hideMenu: function() {
      this.$root.$emit("bv::hide::popover");
    },
  },
};
</script>
